"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appendFilters = void 0;
var tslib_1 = require("tslib");
// (C) 2020 GoodData Corporation
var sdk_model_1 = require("@gooddata/sdk-model");
var partition_1 = tslib_1.__importDefault(require("lodash/fp/partition"));
var zip_1 = tslib_1.__importDefault(require("lodash/fp/zip"));
/**
 * Appends a set of filters to an existing set making sure that all the filters compared regardless of their ObjRef types.
 * Uses {@link mergeFilters} internally, see its docs for details on the merging logic.
 *
 * @param originalFilters - original filter set
 * @param addedFilters - filters to append
 * @param objRefNormalizer - function that converts any ObjRef type to uri
 */
function appendFilters(originalFilters, addedFilters, objRefNormalizer) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var _a, normalizedOriginalFilters, normalizedAddedFilters, _b;
        return tslib_1.__generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!allUseSameRefType(tslib_1.__spreadArrays(originalFilters, addedFilters))) return [3 /*break*/, 1];
                    _b = [originalFilters, addedFilters];
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, Promise.all([
                        normalizeFilterRefs(originalFilters, objRefNormalizer),
                        normalizeFilterRefs(addedFilters, objRefNormalizer),
                    ])];
                case 2:
                    _b = _c.sent();
                    _c.label = 3;
                case 3:
                    _a = _b, normalizedOriginalFilters = _a[0], normalizedAddedFilters = _a[1];
                    return [2 /*return*/, sdk_model_1.mergeFilters(normalizedOriginalFilters, normalizedAddedFilters)];
            }
        });
    });
}
exports.appendFilters = appendFilters;
var isFilterWithoutRefs = function (filter) {
    return sdk_model_1.isMeasureValueFilter(filter) || sdk_model_1.isRankingFilter(filter);
};
/**
 * Detects if all the filters with refs use the same ObjRef type.
 *
 * @param filters - the filters to check
 */
function allUseSameRefType(filters) {
    var filtersWithRefs = filters.filter(function (f) { return !isFilterWithoutRefs(f); });
    return (filtersWithRefs.every(function (f) { return sdk_model_1.isIdentifierRef(sdk_model_1.filterObjRef(f)); }) ||
        filtersWithRefs.every(function (f) { return sdk_model_1.isUriRef(sdk_model_1.filterObjRef(f)); }));
}
/**
 * Makes sure that all the filters use the same ObjRef type so that they can be compared trivially.
 *
 * @param filters - filters to normalize
 * @param objRefNormalizer - function that converts any ObjRef type to uri
 */
function normalizeFilterRefs(filters, objRefNormalizer) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var _a, filtersWithoutRefs, filtersWithRefs, refs, uris, normalized;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = partition_1.default(isFilterWithoutRefs, filters), filtersWithoutRefs = _a[0], filtersWithRefs = _a[1];
                    refs = filtersWithRefs.map(sdk_model_1.filterObjRef);
                    return [4 /*yield*/, objRefNormalizer(refs)];
                case 1:
                    uris = _b.sent();
                    normalized = zip_1.default(filtersWithRefs, uris).map(function (_a) {
                        var filter = _a[0], uri = _a[1];
                        if (sdk_model_1.isAbsoluteDateFilter(filter)) {
                            var _b = sdk_model_1.absoluteDateFilterValues(filter), from = _b.from, to = _b.to;
                            return sdk_model_1.newAbsoluteDateFilter(sdk_model_1.uriRef(uri), from, to);
                        }
                        else if (sdk_model_1.isRelativeDateFilter(filter)) {
                            var _c = sdk_model_1.relativeDateFilterValues(filter), granularity = _c.granularity, from = _c.from, to = _c.to;
                            return sdk_model_1.newRelativeDateFilter(sdk_model_1.uriRef(uri), granularity, from, to);
                        }
                        else if (sdk_model_1.isPositiveAttributeFilter(filter)) {
                            var elements = sdk_model_1.filterAttributeElements(filter);
                            return sdk_model_1.newPositiveAttributeFilter(sdk_model_1.uriRef(uri), elements);
                        }
                        else if (sdk_model_1.isNegativeAttributeFilter(filter)) {
                            var elements = sdk_model_1.filterAttributeElements(filter);
                            return sdk_model_1.newNegativeAttributeFilter(sdk_model_1.uriRef(uri), elements);
                        }
                        else {
                            return filter;
                        }
                    });
                    return [2 /*return*/, tslib_1.__spreadArrays(filtersWithoutRefs, normalized)];
            }
        });
    });
}
//# sourceMappingURL=filterMerging.js.map